import { FoxRequestHeader } from "../domain/fox-request-header";
export const SyncReservationRequest = function (data) {
  if (!data) data = {};
  this.requestHeader = new FoxRequestHeader({ requestType: "POST" });
  this.reservationCode = data.reservationCode || null;
};
